import React from 'react';
import { Brain, Network, MessageSquare, Eye, TrendingUp, Zap } from 'lucide-react';
import { aiCapabilities } from '../mockData';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

const iconMap = {
  brain: Brain,
  network: Network,
  'message-square': MessageSquare,
  eye: Eye,
  'trending-up': TrendingUp,
  zap: Zap
};

const AICapabilities = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#1A3E6E] font-semibold text-sm uppercase tracking-wide">
            AI Capabilities
          </span>
          <h2 className="mt-4 text-4xl lg:text-5xl font-bold text-gray-900">
            Next-Generation AI Solutions
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
            Leverage cutting-edge artificial intelligence to transform your business operations
            and unlock new opportunities for growth.
          </p>
        </div>

        {/* Capabilities Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {aiCapabilities.map((capability) => {
            const IconComponent = iconMap[capability.icon];
            return (
              <Card
                key={capability.id}
                className="hover:shadow-xl transition-all duration-300 border-2 hover:border-[#1A3E6E] group"
              >
                <CardHeader>
                  <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-[#1A3E6E] transition-colors duration-300">
                    <IconComponent className="text-[#1A3E6E] group-hover:text-white transition-colors duration-300" size={28} />
                  </div>
                  <CardTitle className="text-xl group-hover:text-[#1A3E6E] transition-colors">
                    {capability.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-gray-600">
                    {capability.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* AI Technologies Highlight */}
        <div className="mt-16 bg-gradient-to-r from-[#1A3E6E] to-[#1A3E6E] rounded-2xl p-8 text-white">
          <div className="text-center">
            <h3 className="text-3xl font-bold mb-4">Powered by Leading AI Platforms</h3>
            <p className="text-xl text-white/90 mb-6">We work with the latest AI technologies and frameworks</p>
            <div className="flex flex-wrap justify-center gap-4">
              {['OpenAI GPT-5', 'TensorFlow', 'PyTorch', 'LangChain', 'Hugging Face', 'Anthropic Claude'].map((tech) => (
                <span key={tech} className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-medium">
                  {tech}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AICapabilities;
